export default {
    methods: {
        hasError(name){
            if(this.errors === null || this.errors === {}){
                return false
            }
            if(name === undefined && this.errors['message'] !== undefined){
                return true
            }
            if((((this.errors || {}).errors || {})[name] || {}).length > 0){
                return true
            }
            if((this.errors[name] || {}).length >0){
                return true
            }
            return false
        },
        getError(field){
            if(!this.hasError(field)){
                return ''
            }
            if(!field){
                return this.errors['message']
            }
            return (this.errors[field] || this.errors.errors[field]).join(' ')
        },
    }
}